window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.directive('select2', {
    inserted(element) {
        $(element).on('select2:select', () => {;
            let changeEvent = new Event("change", {bubbles: false, cancelable: false});
            element.dispatchEvent(changeEvent);
        });

        $(element).on('select2:unselect', () => {
            let changeEvent = new Event("change", {bubbles: false, cancelable: false});
            element.dispatchEvent(changeEvent);
        })
    },
});

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('datatables-component', require('./components/DataTablesComponent.vue').default);
Vue.component('datatables-header-column-component', require('./components/DataTablesHeaderColumnComponent.vue').default);
Vue.component('items-table-component', require('./components/ItemsTableComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.prototype.Base64 = window.Base64;

const app = new Vue({
    el: '#app',
});
